import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnouncementsComponent } from './announcements.component';
import { FormsModule } from '@angular/forms';
import { TabsModule } from '../../components/tabs/tabs.module';
import { RouterModule } from '@angular/router';
import { CommonComponentsModule } from '../../common-components.module';
import { DatetimeModule } from '../../components/datetime/datetime.module';
import { FieldsModule } from '../../components/fields/fields.module';
import { AnnouncementsListComponent } from './announcements-list/announcements-list.component';
import { AnnouncementsViewModalComponent } from './announcements-view-modal/announcements-view-modal.component';
import { AnnouncementsService } from '../../services/announcements.service';
import { AnnouncementsAddComponent } from './announcements-add/announcements-add.component';
import { AngularMaterialImportModule } from '../../components/angular-material-import-module/angular-material-import.module';
import { FileUploadModule } from '../../components/file-upload/file-upload.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AnnouncementViewComponent } from './announcement-view/announcement-view.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        FileUploadModule,
        PdfViewerModule,
        UtilsModule,
    ],
    declarations: [
        AnnouncementsComponent,
        AnnouncementsListComponent,
        AnnouncementsViewModalComponent,
        AnnouncementsAddComponent,
        AnnouncementViewComponent,
    ],
    providers: [
        AnnouncementsService,
    ],
    exports: [
        AnnouncementViewComponent
    ],
    entryComponents: [
        AnnouncementsViewModalComponent
    ]
})
export class AnnouncementsModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements.module.ts